import styled from "@emotion/styled";
import { color } from "metabase/lib/colors";

const SectionDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${color("border")};
`;

// eslint-disable-next-line import/no-default-export -- deprecated usage
export default SectionDivider;
